import { useFormContext } from 'ui-builder';
import { Permission, useAuthorizationScopeContext } from './authorizationScopeContext';

export function useAuthorizationChecker() {
  const context = useAuthorizationScopeContext();

  const { data: formContextData } = useFormContext();

  const isGranted = (permission: Permission): boolean => {
    const permissions = context || [];
    return permissions.permissions.includes(permission)
      || (formContextData?.permissions && formContextData.permissions.includes(permission));
  };

  return {
    isGranted,
    isLoaded: context.isLoaded,
  };
}
